import { useMemo } from 'react';

import { useHistory, useLocation } from 'react-router';

// TODO: React Router v6 ships with its own useSearchParams() hook.
// We should switch to that once RR is upgraded.
// https://reactrouter.com/docs/en/v6/examples/search-params
function useSearchParams() {
  const history = useHistory();

  const { search } = useLocation();

  const searchParams = useMemo(() => new URLSearchParams(search), [search]);

  function setSearchParam(name: string, value: string, replace = false) {
    if (!value) {
      searchParams.delete(name);
    } else {
      searchParams.set(name, value);
    }

    if (replace) {
      history.replace({ search: searchParams.toString() });
    } else {
      history.push({ search: searchParams.toString() });
    }
  }

  return [searchParams as URLSearchParams, setSearchParam] as const;
}

export { useSearchParams };
